/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc
 */

export const BooleanFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const BooleanFilterQueryDiscriminant = 'BooleanFilterQuery';
export const BooleanFilterQueryDiscriminantKey = '@type';
export const ExistsFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const ExistsFilterQueryDiscriminant = 'ExistsFilterQuery';
export const ExistsFilterQueryDiscriminantKey = '@type';
export const FilterQueryDiscriminantKey = '@type';
export const FloatFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const FloatFilterQueryDiscriminant = 'FloatFilterQuery';
export const FloatFilterQueryDiscriminantKey = '@type';
export const LongFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
export const LongFilterQueryDiscriminant = 'LongFilterQuery';
export const LongFilterQueryDiscriminantKey = '@type';
export const StringFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
export const StringFilterQueryDiscriminant = 'StringFilterQuery';
export const StringFilterQueryDiscriminantKey = '@type';
export const getCollectionBySlugRpc = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc',
  rpcName: 'getCollectionBySlug',
  auth: 'external',
  fingerprint: '7pOoj7ByMLU8undBI6VpV53WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc',
  rpcName: 'getAllCollections',
  auth: 'external',
  fingerprint: 'wTJXCGMoz02xkA07QQ5q8J3WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};